import Skeleton from 'react-loading-skeleton'
interface SkeletonRowProps {
  count: number
}
const SkeletonRow: React.FC<SkeletonRowProps> = ({ count }) => (
  <tr>
    <td colSpan={15} className='py-2'>
      <Skeleton
        width={'100%'}
        height={52}
        baseColor='var(--kt-skeleton-bg-color)'
        highlightColor='var(--kt-skeleton-highlight-bg-color)'
        count={count}
      />
    </td>
  </tr>
)

export default SkeletonRow
